import type { IconSvgObject } from './types';

const DatabaseZapIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "5.00195", rx: "8", ry: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 15.002C7.58172 15.002 4 13.6588 4 12.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 22.002C7.58172 22.002 4 20.6588 4 19.002V5.00195M20 5.00195V10.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 14.002L16 18.002H20L18 22.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default DatabaseZapIcon;
